export default __webpack_public_path__ + "b5443ec6caf63a984de9873f0b545d2a.svg";